/**
 * 基础公共编辑器工具栏
 * @description 默认配置 => [上传图片 | 新建公式 | 插入公式 | 加粗 | 斜体 | 下划线 | 删除线 | 撤销 | 重做/重复 ]
 * @type {string[]}
 */
export const commonToolbar = [
  'customImageButton customFormulaButton customToolButton bold italic underline strikethrough undo redo',
]
